module.exports = __webpack_public_path__ + "img/book-f0f0e99.jpg";